import React, { useState } from 'react';
import styles from "./introduction.module.scss";
import useScrollToView from '../../utils/hooks/useScrollToView';
import SpiderMan from '../terminal/terminal';

const Introduction = () => {
    const [showText, setShowText] = useState(false); // Control text visibility
    const scrollToRef = useScrollToView('overview');

    return (
        <section id="introduction" className={`relative h-[100vh] flex flex-col justify-center items-center`}>
            <SpiderMan onTerminalDisappear={() => setShowText(true)} />
            {showText && (
                <section className={styles.intoduction}>
                    <h1 className={`lg:text-[4rem] text-[2rem] animate-fade-up`}>
                        Hello, I'm Mansi Patil
                    </h1>
                    <p className={`text-lg md:text-xl animate-fade-up-delay`}>
                        and I'm delighted to present my professional portfolio, showcasing my expertise and accomplishments in Software Engineer field.
                    </p>
                </section>
            )}
            <div className="absolute sm:bottom-20 bottom-10 w-full flex justify-center items-center z-[1]">
                <button ref={scrollToRef}>
                    <div className="flex flex-col items-center space-y-1 animate-bounce">
                        <span className="text-white text-xl">&#x25BC;</span>
                        <span className="text-white text-xl">&#x25BC;</span>
                    </div>
                </button>
            </div>
      


        </section>
    );
};

export default Introduction;
